// Accessible, responsive slider for #heroSlider with directional infinite scroll
(function(){
  function initSlider() {
    const root = document.getElementById('heroSlider');
    if(!root) return;
    
    const track = root.querySelector('.slides');
    const slides = Array.from(root.querySelectorAll('.slide'));
    const prevBtn = root.querySelector('.slider-btn.prev');
    const nextBtn = root.querySelector('.slider-btn.next');
    const dots = Array.from(root.querySelectorAll('.dot'));
    
    let currentIndex = 0;
    let timer = null;
    const INTERVAL = 5000;
    const slideCount = slides.length;
    let isTransitioning = false;

    function updateUI() {
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === currentIndex);
        slide.setAttribute('aria-label', `${i+1} / ${slideCount}`);
      });
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === currentIndex);
        dot.setAttribute('aria-selected', i === currentIndex ? 'true' : 'false');
      });
    }

    function goToSlide(targetIndex, direction = 'auto') {
      if (isTransitioning || targetIndex === currentIndex) return;
      
      isTransitioning = true;
      
      // 방향 결정
      let actualDirection;
      if (direction === 'auto') {
        if (currentIndex === 2 && targetIndex === 0) {
          // 3번에서 1번으로 갈 때 우->좌 방향 유지
          actualDirection = 'next';
        } else if (currentIndex === 0 && targetIndex === 2) {
          // 1번에서 3번으로 갈 때 좌->우 방향 유지
          actualDirection = 'prev';
        } else {
          actualDirection = targetIndex > currentIndex ? 'next' : 'prev';
        }
      } else {
        actualDirection = direction;
      }
      
      // 임시 슬라이드 생성하여 무한 스크롤 효과
      if (actualDirection === 'next' && currentIndex === 2 && targetIndex === 0) {
        // 3->1 무한 스크롤을 위한 임시 슬라이드 추가
        const tempSlide = slides[0].cloneNode(true);
        tempSlide.removeAttribute('id');
        tempSlide.classList.remove('is-active');
        track.appendChild(tempSlide);
        
        // 4번째 위치로 이동
        track.style.transition = 'transform 0.5s ease-in-out';
        track.style.transform = 'translateX(-300%)';
        
        setTimeout(() => {
          // 임시 슬라이드 제거하고 첫 번째 슬라이드로 점프
          track.removeChild(tempSlide);
          track.style.transition = 'none';
          track.style.transform = 'translateX(0%)';
          currentIndex = 0;
          updateUI();
          isTransitioning = false;
        }, 500);
        
      } else if (actualDirection === 'prev' && currentIndex === 0 && targetIndex === 2) {
        // 1->3 역방향 무한 스크롤을 위한 임시 슬라이드 추가
        const tempSlide = slides[2].cloneNode(true);
        tempSlide.removeAttribute('id');
        tempSlide.classList.remove('is-active');
        track.insertBefore(tempSlide, slides[0]);
        
        // 위치 조정 (임시 슬라이드가 추가되었으므로)
        track.style.transition = 'none';
        track.style.transform = 'translateX(-100%)';
        
        setTimeout(() => {
          // -200% 위치로 이동 (3번째 원본으로)
          track.style.transition = 'transform 0.5s ease-in-out';
          track.style.transform = 'translateX(-300%)';
          
          setTimeout(() => {
            // 임시 슬라이드 제거하고 세 번째 슬라이드로 점프
            track.removeChild(tempSlide);
            track.style.transition = 'none';
            track.style.transform = 'translateX(-200%)';
            currentIndex = 2;
            updateUI();
            isTransitioning = false;
          }, 500);
        }, 10);
        
      } else {
        // 일반적인 슬라이드 이동
        currentIndex = targetIndex;
        const offset = -currentIndex * 100;
        track.style.transition = 'transform 0.5s ease-in-out';
        track.style.transform = `translateX(${offset}%)`;
        updateUI();
        
        setTimeout(() => {
          isTransitioning = false;
        }, 500);
      }
    }

    function next() {
      const nextIndex = (currentIndex + 1) % slideCount;
      goToSlide(nextIndex, 'next');
    }

    function prev() {
      const prevIndex = (currentIndex - 1 + slideCount) % slideCount;
      goToSlide(prevIndex, 'prev');
    }

    function start() { 
      stop(); 
      timer = setInterval(next, INTERVAL); 
    }
    
    function stop() { 
      if(timer) { 
        clearInterval(timer); 
        timer = null; 
      } 
    }

    // Controls
    prevBtn.addEventListener('click', prev);
    nextBtn.addEventListener('click', next);
    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => goToSlide(i));
    });

    // Pause on hover/focus
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    // Keyboard
    root.addEventListener('keydown', e => {
      if(e.key === 'ArrowLeft') { e.preventDefault(); prev(); }
      if(e.key === 'ArrowRight') { e.preventDefault(); next(); }
    });
    root.setAttribute('tabindex','0');

    // 초기화
    updateUI();
    start();
  }

  // DOM이 로드된 후 또는 이미 로드되었으면 즉시 실행
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSlider);
  } else {
    initSlider();
  }
})();
